import { render, staticRenderFns } from "./OpportunityProductsSelect.vue?vue&type=template&id=3407e28c&scoped=true&"
import script from "./OpportunityProductsSelect.vue?vue&type=script&lang=js&"
export * from "./OpportunityProductsSelect.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityProductsSelect.vue?vue&type=style&index=0&id=3407e28c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3407e28c",
  null
  
)

export default component.exports